module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    staticStyle: {
      "background": "#f0d803"
    },
    attrs: {
      "id": "wrap"
    }
  }, [_c('div', {
    staticClass: "pager"
  }, [_c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin-top": "1em",
      "text-align": "center"
    }
  }, [_c('h2', [_vm._v("AfiaApp")]), _vm._v(" "), _c('h4', [_vm._v("Olandigo"), _c('br'), _vm._v("-"), _c('br'), _vm._v("Edonland")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin-top": "1em",
      "text-align": "center"
    }
  }, [_c('p', [_vm._v("-View/Check verified Shops")]), _vm._v(" "), _c('p', [_vm._v("-Buy Better")]), _vm._v(" "), _c('p', [_vm._v("-Create and Share Store/Shop")]), _vm._v(" "), _c('p', [_vm._v("-Upload Product and Services")]), _vm._v(" "), _c('p', [_vm._v("-Share and Sell")]), _vm._v(" "), _c('p', [_vm._v("-Refer and Earn")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8 col-xs-offset-3",
    staticStyle: {
      "margin-top": "1em",
      "text-align": "left",
      "font-weight": "bold"
    }
  }, [_c('p', [_c('b', [_vm._v("-------")])]), _vm._v(" "), _c('p', [_vm._v("-POS Buying")]), _vm._v(" "), _c('p', [_vm._v("-Cashless Payments")]), _vm._v(" "), _c('p', [_vm._v("-Buy from home, Deliver to me")]), _vm._v(" "), _c('p', [_vm._v("-Buy from home, Pickup at Market")]), _vm._v(" "), _c('p', [_vm._v("-Remote Order, Pay at Market ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin-top": "0.4em",
      "text-align": "center"
    }
  }, [_c('a', {
    staticClass: "btn sp-button-1",
    staticStyle: {
      "margin": "1em"
    },
    attrs: {
      "href": "/register"
    }
  }, [_vm._v("Get Started")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-313a493e"}!./src/pages/Home/template.html
// module id = 390
// module chunks = 0